export const env = {
  posthog: process.env.NEXT_PUBLIC_POSTHOG_KEY,
};
